module.exports = __webpack_public_path__ + "fonts/Roboto-Light.0bfbc9a.woff2";